import { render } from "./ShipmentDetails.vue?vue&type=template&id=5e7490cf&scoped=true"
import script from "./ShipmentDetails.vue?vue&type=script&lang=js"
export * from "./ShipmentDetails.vue?vue&type=script&lang=js"

import "./ShipmentDetails.vue?vue&type=style&index=0&id=5e7490cf&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e7490cf"]])

export default __exports__